export default function (state, resolve) {
    if (resolve) {
        state.resolves.push(resolve);
    } else {
        state.resolves.forEach(i => {
            i(state);
        });
        state.resolves = [];
    }
}